"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeProfilerApi = makeProfilerApi;
const browser_rum_core_1 = require("@datadog/browser-rum-core");
const browser_core_1 = require("@datadog/browser-core");
const profilingSupported_1 = require("../domain/profiling/profilingSupported");
const profilingContext_1 = require("../domain/profiling/profilingContext");
const lazyLoadProfiler_1 = require("./lazyLoadProfiler");
function makeProfilerApi() {
    let profiler;
    function onRumStart(lifeCycle, hooks, configuration, sessionManager, viewHistory, createEncoder) {
        const session = sessionManager.findTrackedSession(); // Check if the session is tracked.
        if (!session) {
            // No session tracked, no profiling.
            // Note: No Profiling context is set at this stage.
            return;
        }
        // Sampling (sticky sampling based on session id)
        if (!(0, browser_rum_core_1.isSampled)(session.id, configuration.profilingSampleRate)) {
            // No sampling, no profiling.
            // Note: No Profiling context is set at this stage.
            return;
        }
        // Listen to events and add the profiling context to them.
        const profilingContextManager = (0, profilingContext_1.startProfilingContext)(hooks);
        // Browser support check
        if (!(0, profilingSupported_1.isProfilingSupported)()) {
            profilingContextManager.set({
                status: 'error',
                error_reason: 'not-supported-by-browser',
            });
            return;
        }
        (0, lazyLoadProfiler_1.lazyLoadProfiler)()
            .then((createRumProfiler) => {
            if (!createRumProfiler) {
                // monitor-until: 2026-01-01, reconsider after profiling GA
                (0, browser_core_1.addTelemetryDebug)('[DD_RUM] Failed to lazy load the RUM Profiler');
                profilingContextManager.set({ status: 'error', error_reason: 'failed-to-lazy-load' });
                return;
            }
            profiler = createRumProfiler(configuration, lifeCycle, sessionManager, profilingContextManager, createEncoder);
            profiler.start(viewHistory.findView());
        })
            .catch(browser_core_1.monitorError);
    }
    return {
        onRumStart,
        stop: () => {
            profiler === null || profiler === void 0 ? void 0 : profiler.stop().catch(browser_core_1.monitorError);
        },
    };
}
//# sourceMappingURL=profilerApi.js.map